import { render } from "./InformationHeader.vue?vue&type=template&id=73e83c1c&scoped=true&ts=true"
import script from "./InformationHeader.vue?vue&type=script&lang=ts"
export * from "./InformationHeader.vue?vue&type=script&lang=ts"

import "./InformationHeader.vue?vue&type=style&index=0&id=73e83c1c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e83c1c"]])

export default __exports__
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerDots});
